import React, { useCallback, useEffect, useRef } from 'react';
import { Editor } from '@toast-ui/react-editor';
import debounce from 'lodash/debounce';

import '@toast-ui/editor/dist/toastui-editor.css';

export interface RichTextareaProps {
  value?: string;
  onChange?: (value: string) => void;
  onBlur?: (value: string) => void;
  autoFocus?: boolean;
  autosaveInterval?: number;
  autosave?: (value: string) => void;
}

const RichTextarea: React.FC<RichTextareaProps> = ({
  value,
  onChange,
  onBlur,
  autoFocus,
  autosaveInterval = 5000,
  autosave,
}) => {
  const editorRef = useRef(null);

  const getValue = () => editorRef.current?.getInstance?.().getMarkdown();
  const setValue = (value: string) =>
    editorRef.current?.getInstance?.().setMarkdown(value);

  const debouncedSave = useCallback(
    debounce(() => {
      autosave?.(getValue());
    }, autosaveInterval),
    [autosave, autosaveInterval],
  );

  useEffect(() => {
    if (value !== getValue()) {
      setValue(value || '');
    }
  }, [value]);

  return (
    <Editor
      ref={editorRef}
      usageStatistics={false}
      hideModeSwitch
      autofocus={!!autoFocus}
      height="70vh"
      initialEditType="wysiwyg"
      onChange={() => {
        onChange?.(getValue());
        debouncedSave();
      }}
      onBlur={() => onBlur?.(getValue())}
    />
  );
};

export default RichTextarea;
